import { render, staticRenderFns } from "./report-score.vue?vue&type=template&id=2a02257e&scoped=true&"
import script from "./report-score.vue?vue&type=script&lang=js&"
export * from "./report-score.vue?vue&type=script&lang=js&"
import style0 from "./report-score.vue?vue&type=style&index=0&id=2a02257e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a02257e",
  null
  
)

export default component.exports